/**
 * Constants.ts
 *
 * A module for non-UI constants.
 */
/**
 * Values for types of feedback that go into the json
 * Also used to determine the FormTemplate used on each one of the feedback types.
 */
export var FeedbackType;
(function (FeedbackType) {
  FeedbackType[FeedbackType["Smile"] = 0] = "Smile";
  FeedbackType[FeedbackType["Frown"] = 1] = "Frown";
  FeedbackType[FeedbackType["Idea"] = 2] = "Idea";
  FeedbackType[FeedbackType["Bug"] = 3] = "Bug";
})(FeedbackType || (FeedbackType = {}));
/**
 * Dynamic scripts
 */
export class DynamicScriptUrls {}
/**
 * Link to the Office WebSurfaces UX package
 */
/* tslint:disable:max-line-length */
DynamicScriptUrls.WebSurfacesLink = "https://content.growth.office.net/mirrored/resources/programmablesurfaces/prod/officewebsurfaces.core.min.js";
/**
 * Constant GUIDs
 */
export class GUIDs {}
GUIDs.TMSAppID = "4c4f550b-42b2-4a16-93f9-fdb9e01bb6ed";
GUIDs.TULIPSAppID = "05c88d91-956e-46b4-91b0-77a33cc21a4d";